import { apiSlice } from "../../app/api/apiSlice";

export const attachEnhancedConditionDocumentApiSlice = apiSlice.injectEndpoints(
	{
		endpoints: (builder) => ({
			attachEnhancedConditionDocument: builder.mutation({
				query: (credentials) => ({
					url: `/api/v1/loan/attach_enhanced_condition_document/${credentials?.loanGuid}/conditions/${credentials?.conditionId}/`,
					method: "POST",
					body: credentials?.data,
				}),
			}),
		}),
	}
);

export const { useAttachEnhancedConditionDocumentMutation } =
	attachEnhancedConditionDocumentApiSlice;
